







import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import Datepicker from "vuejs-datepicker";

@Component({
    components: {
        "datepicker": Datepicker
    }
})
export default class StartDate extends Vue {
    @Prop() selectedDate!: Date;

    @Emit()
    dateChanged(selected: Date) {
        return selected;
    }
}
